import React, { FormEvent, useEffect, useRef, useState } from 'react'
import './live-api.css'
import '../api-details/api-details.css'
import MainContainer from "../../components/container/MainContainer"; import Breadcrumb from '../../components/breadcrumb/Breadcrumb'
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants'
import betaIcon from '../../assets/card-icons/beta.svg'
import prodIcon from '../../assets/card-icons/stable.svg'
import clockIcon from '../../assets/clock.svg'
import CustomCharts from '../../components/CustomCharts/CustomCharts'
import { useLocation, useParams } from 'react-router-dom'
import { postDetails } from '../../services/http/http.service'
import APIList from '../../utils/constants/APIList'
import decrypt from '../../utils/helpers/decrypt'
import { APIResponseCodes } from '../../utils/constants/keys.constants'
import { hideLoader, showLoader } from '../../store/Loader/loader.slice'
import { useAppDispatch, useAppSelector } from '../../store/storeRequests'
import { TrackAPIDetailsInterface } from '../../utils/constants/Interfaces.constants'
import Share from '../../components/Share/Share'
import { getAPIHealthChart, getAPIStatisticsChart } from '../../store/chartState/chartState.actions'
import { setInitLineChart, setInitPieChart } from '../../store/chartState/chartState.slice'
import ModalWrapper from '../../components/Modal/ModalWrapper'
import CustomDatepicker from '../../components/CustomDatepicker/CustomDatepicker'
import CustomButton from '../../components/CustomButton/CustomButton'
import formatDate from '../../utils/constants/formatDate'
import jsonToExcel from '../../utils/helpers/jsonToExcel'
import StoreSelectors from '../../utils/constants/StoreSelectors.constants'
import { message } from '../../utils/constants/Messages';

const LiveAPI: React.FunctionComponent<any> = () => {

    const isUIMounted = useRef(false)
    const dateModalRef = useRef(null)

    const { usageChartData } = useAppSelector(StoreSelectors.CHART_STATE)

    const filterDropdownOptions = [
        { id: 1, name: 'This Week' },
        { id: 2, name: 'This Month' },
        { id: 3, name: 'Last 3 Months' },
        { id: 4, name: 'Custom Date' },
    ]
    const location = useLocation()
    const params = useParams()
    const dispatch = useAppDispatch()

    const { group_id, group_version_id, group_name } = location.state || {};
    const [showShare, setShowShare] = useState(false)
    const [showVersionDropdown, setShowVersionDropdown] = useState(false)
    const [apiData, setAPIData] = useState<TrackAPIDetailsInterface>({
        api_type: '',
        api_version_id: 0,
        master_api_id: 0,
        environment: 'beta',
        name: '',
        api_version: '',
        versions: [],
        averageResponseTime: ''
    })
    const [minCalendarDate, setMinCalendarDate] = useState(new Date('1/1/2023'))
    const [selectedVersion, setSelectedVersion] = useState('')
    const [currentUsageFilter, setCurrentUsageFilter] = useState({ id: 1, name: 'this week' })
    const [currentHealthFilter, setCurrentHealthFilter] = useState({ id: 5, name: 'Today' })
    const [usageDateRange, setUsageDateRange] = useState({ start: new Date(), end: new Date() } as { start: Date, end: Date })
    const [healthDateRange, setHealthDateRange] = useState({ start: new Date(), end: new Date() } as { start: Date, end: Date })
    const [err, setErr] = useState('')
    const [currentModalName, setCurrentModalName] = useState('' as any)

    const getAPIbyID = async () => {
        dispatch(showLoader(message.GETTING_API_DETAILS))
        try {
            if (typeof params.id !== 'undefined') {
                const response = await postDetails(APIList.GET_API_BY_ID, { id: parseInt(decodeURIComponent(decrypt(params.id))) }, getAPIbyID)
                if (response.statusCode === APIResponseCodes.SUCCESS) {

                    const filterOptions = {
                        "master_api_id": response.data?.master_api_id,
                        "api_version_id": response.data?.ap_ver_id,
                        "group_id": group_id,
                        "group_version_id": group_version_id,
                        "filter": "This Week",
                        "customStartDate": "",
                        "customEndDate": ""
                    }

                    const returnResponse = await dispatch(getAPIStatisticsChart(filterOptions))

                    setMinCalendarDate(new Date(returnResponse.orderApprovedDate) || new Date('1/1/2023'))
                    setAPIData({
                        name: response.data?.name || '',
                        api_version: response.data?.api_version || '',
                        environment: response.data?.enviroment || 'beta',
                        versions: response.data?.version_list || [],
                        api_type: response.data?.api_type || '',
                        api_version_id: response.data?.ap_ver_id || 0,
                        master_api_id: response.data?.master_api_id || 0,
                        averageResponseTime: returnResponse !== null ? returnResponse.averageResponseTime : ''
                    })
                    setSelectedVersion(response.data?.api_version || '')
                    dispatch(getAPIHealthChart({ ...filterOptions, 'filter': currentHealthFilter.name }))
                }
            }
            dispatch(hideLoader())
        } catch (error) {
            dispatch(hideLoader())
            console.log(error)
        }
    }

    useEffect(() => {
        if (isUIMounted.current === true) return
        isUIMounted.current = true
        getAPIbyID()
    }, [])

    /** Get version data - based on dropdown selection */
    const getVersionData = async (version: { id: number; api_version: string; }) => {
        if (selectedVersion.toLowerCase() === version.api_version.toLowerCase()) {
            setShowVersionDropdown(false)
            return
        }
        dispatch(showLoader(message.GETTING_VERSION_DOC))
        let reqPayload
        if (typeof params.id !== 'undefined') {
            reqPayload = { id: apiData.master_api_id, api_version: `${version.api_version}` }
        }
        try {
            const response = await postDetails(APIList.GET_API_BY_VERSION, reqPayload, () => getVersionData(version))
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                setSelectedVersion(version.api_version)
                const filterOptions = {
                    "master_api_id": response.data?.master_api_id,
                    "api_version_id": response.data?.api_version_id,
                    "group_id": group_id,
                    "group_version_id": group_version_id,
                    "filter": "This Week",
                    "customStartDate": "",
                    "customEndDate": ""
                }
                dispatch(setInitLineChart(false))
                const returnResponse = await dispatch(getAPIStatisticsChart(filterOptions))
                setAPIData({
                    ...apiData,
                    api_version: response.data.api_version || '',
                    api_version_id: response.data.api_version_id || 0,
                    averageResponseTime: returnResponse !== null ? returnResponse.averageResponseTime : ''
                })
                dispatch(setInitPieChart(false))
                await dispatch(getAPIHealthChart(filterOptions))
            }

            dispatch(hideLoader())
            setShowVersionDropdown(false)
        } catch (error) {
            console.log(error)
            dispatch(hideLoader())
        }
    }

    /** Open dates modal  */
    const openDatesModal = () => {
        if (dateModalRef.current !== null) {
            const modal: { toggleModalWrapper: Function } = dateModalRef.current
            modal.toggleModalWrapper(true)
        }
    }

    /** Handle dropdown filter change */
    const handleDropdownFilterChange = async (filterFrom: 'usage' | 'status', selected: { id: number, name: string }) => {
        setErr('')
        if (filterFrom !== currentModalName) {
            filterFrom === 'usage' ? setUsageDateRange({ start: new Date(), end: new Date() }) : setHealthDateRange({ start: new Date(), end: new Date() })
        }
        if (selected.id === 4) {
            openDatesModal()
            setCurrentModalName(filterFrom)
            return
        }

        let filterOptions: any = {
            "master_api_id": apiData.master_api_id,
            "api_version_id": apiData.api_version_id,
            "group_id": group_id,
            "group_version_id": group_version_id,
            "filter": filterFrom === 'usage' ? selected.name : selected.name,
            "customStartDate": "",
            "customEndDate": ""
        }

        if (selected.id === 4) {
            filterOptions = {
                ...filterOptions,
                customStartDate: filterFrom === 'usage' ? usageDateRange.start : healthDateRange.start,
                customEndDate: filterFrom === 'usage' ? usageDateRange.end : healthDateRange.end
            }
        }

        if (filterFrom === 'usage') {
            setCurrentUsageFilter(selected)
            await dispatch(getAPIStatisticsChart(filterOptions))
            setCurrentModalName('')
        }

        if (filterFrom === 'status') {
            dispatch(setInitPieChart(false))
            setCurrentHealthFilter(selected)
            await dispatch(getAPIHealthChart(filterOptions))
            setCurrentModalName('')
        }
    }

    /** hanlde date range selection */
    const handleDateSelection = (date: Date | null, event: React.SyntheticEvent<any, Event> | undefined, calenderKey: "" | "start" | "end") => {
        setErr('')
        if (date === null) return

        if (calenderKey === 'start') {
            if (new Date(date).getTime() > new Date(currentModalName === 'usage' ? usageDateRange.end : healthDateRange.end).getTime()) {
                setErr('Start date cannot be greater than end date...')
                setTimeout(() => setErr(''), 2000)
                return
            }
            currentModalName === 'usage' ? setUsageDateRange({ ...usageDateRange, start: date }) : setHealthDateRange({ ...healthDateRange, start: date })
        }
        if (calenderKey === 'end') {
            currentModalName === 'usage' ? setUsageDateRange({ ...usageDateRange, end: date }) : setHealthDateRange({ ...healthDateRange, end: date })
        }
    }

    /** Reset Date picker */
    const resetDates = () => {
        setErr('')
        currentModalName === 'usage' ? setUsageDateRange({ start: new Date(), end: new Date() }) : setHealthDateRange({ start: new Date(), end: new Date() })
        setCurrentModalName('')
    }

    const onDatesSubmit = async (ev: FormEvent<HTMLFormElement>) => {
        ev.preventDefault()

        dispatch(showLoader(message.GETTING_DETAILS))
        let filterOptions: any = {
            master_api_id: apiData.master_api_id,
            api_version_id: apiData.api_version_id,
            group_id: group_id,
            group_version_id: group_version_id,
            filter: 'Custom Date',
            customStartDate: formatDate(`${currentModalName === 'usage' ? usageDateRange.start : healthDateRange.start}`, '/'),
            customEndDate: formatDate(`${currentModalName === 'usage' ? usageDateRange.end : healthDateRange.end}`, '/')
        }

        if (currentModalName === 'usage') {
            setCurrentUsageFilter({ id: 4, name: 'Custom Date' })
            await dispatch(getAPIStatisticsChart(filterOptions))
            setCurrentModalName('')
        }

        if (currentModalName === 'status') {
            dispatch(setInitPieChart(false))
            setCurrentHealthFilter({ id: 4, name: 'Custom Date' })
            await dispatch(getAPIHealthChart(filterOptions))
            setCurrentModalName('')
        }

        setCurrentModalName('')
        dispatch(hideLoader())
        if (dateModalRef.current !== null) {
            const modal: { toggleModalWrapper: Function } = dateModalRef.current
            modal.toggleModalWrapper(false)
        }
    }

    /** Get performance report */
    const downloadPerformanceReport = async () => {
        dispatch(showLoader(message.GETTING_PERFORMANCE_REPORT))
        const payload = {
            master_api_id: apiData.master_api_id,
            api_version_id: apiData.api_version_id,
            group_id: group_id,
            group_version_id: group_version_id
        }
        try {
            const response = await postDetails(APIList.GET_API_PERFORMANCE, payload, downloadPerformanceReport)
            const successTemp: Array<any> = []
            const failureTemp: Array<any> = []

            if (response.data.length !== 0) {
                if (response.data?.successResults?.length !== 0) {

                    response.data.successResults.forEach((result: any, index: number) => {
                        successTemp.push({
                            sr_no: index + 1,
                            email: result?.user_email,
                            activity_timestamp: formatDate(result?.activity_datetime, 'datetime'),
                            response_time: result?.response_time,
                            status: result?.status_code,
                            api_status: result?.status
                        })
                    })
                }

                if (response.data?.failureResults?.length !== 0) {

                    response.data.failureResults.forEach((result: any, index: number) => {
                        failureTemp.push({
                            sr_no: index + 1,
                            email: result?.user_email,
                            activity_timestamp: formatDate(result?.activity_datetime, 'datetime'),
                            response_time: result?.response_time,
                            status: result?.status_code,
                            api_status: result?.status
                        })
                    })
                }
            }
            const col_names = [['Sr. No', 'User Email', 'Activity Time', 'Response time', 'status', 'API Status']]
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                dispatch(showLoader(message.DOWNLOAD))
                await jsonToExcel(successTemp.length == 0 && failureTemp.length == 0 ? {} : { success: successTemp, failure: failureTemp }, apiData.name, col_names, true)
            }

            dispatch(hideLoader())

        } catch (error) {
            dispatch(hideLoader())
            console.log(error)
        }
    }

    return (
        <MainContainer>
            <Breadcrumb routes={[...BreadcrumbData.live, { id: '21', routeLabel: apiData.name, route: '' }]} />

            <div className="mf-active-header-padding">
                <div className='mf-live-api-details bg-white'>
                    <div className="api-dev-status">
                        <div className="d-flex justify-content-between">
                            {
                                apiData.environment.toLowerCase() === 'beta' &&
                                <img width={64} height={64} src={betaIcon} alt="uat" />
                            }
                            {
                                apiData.environment.toLowerCase() === 'prod' &&
                                <img width={64} height={64} src={prodIcon} alt="production" />
                            }
                            <div className="d-flex">
                                <div onClick={downloadPerformanceReport} className="api-download cursor-pointer mf-api-download-option me-3"></div>
                                <div onClick={() => setShowShare(true)} className="api-share cursor-pointer mf-api-share-option"></div>
                            </div>
                        </div>
                        <div className="api-basic-texts live-bottom-border">
                            <div className="api-basic-texts-header d-flex">
                                <p className="mb-0 text-sec-color weight-600 text-capitalize">{apiData.name}</p>
                                <div className="version-dropdown position-relative">
                                    <button onClick={() => setShowVersionDropdown(!showVersionDropdown)} type='button' className='weight-500 text-uppercase font-14 text-sec-color version-dropdown-btn text-start'>
                                        {selectedVersion.length === 0 ?
                                            `${apiData.api_version}`.length === 1 ? `V ${apiData.api_version}.0` : `V ${apiData.api_version}`
                                            : selectedVersion.length === 1 ? `V ${selectedVersion}.0` : `V ${selectedVersion}`}
                                    </button>
                                    <ul className={showVersionDropdown ? "version-dropdown-list no-list-style py-2 mb-0 bg-white ps-0" : "d-none"}>
                                        {
                                            apiData.versions.length !== 0 &&
                                            apiData.versions.map((version, index) => (
                                                <li onClick={() => getVersionData(version)} className='weight-500 text-uppercase text-primary-color py-1 px-3 version-dropdown-list-item' key={index}>V {`${version.api_version}`.length === 1 ? ` ${version.api_version}.0` : ' ' + version.api_version}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                            <small className='font-13 weight-500 text-capitalize'>{apiData.api_type}</small>
                            <div className='ms-3 d-inline'>
                                <img width={17} height={17} src={clockIcon} alt="average time" className='me-1' />
                                <small className='font-13 weight-500 text-capitalize pt-2'>{apiData.averageResponseTime}</small>
                            </div>
                        </div>

                    </div>

                    <div className="my-4">
                        <div className="row no-negative-margin">
                            <div className="col-12 col-md-6 col-lg-6 ps-0 pe-0 pe-md-4 pe-lg-4">
                                <div className="chart-container p-3">
                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        <p className="mb-0 font-16 weight-500 text-capitalize text-sec-color">API Usage</p>
                                        <div className="dropdown chart-filters-dropdown">
                                            <button className="dropdown-toggle border-0 font-13 text-sec-color text-capitalize weight-500 text-start" type="button" id="mfChartMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                                {currentUsageFilter.name}
                                            </button>
                                            <ul className="chart-filters-dropdown-menu dropdown-menu" aria-labelledby="mfChartMenu">
                                                {
                                                    filterDropdownOptions.map((item, index) => (
                                                        <li key={index} onClick={() => handleDropdownFilterChange('usage', item)} data-active={item.id === currentUsageFilter.id} className='cursor-pointer font-13 weight-400 text-capitalize'>{item.name}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    {
                                        currentUsageFilter.id === 4 &&
                                        <p className="mb-3 font-13 weight-400">Showing API results between <strong>{formatDate(`${usageDateRange.start}`, 'fullmonth')}</strong> to <strong>{formatDate(`${usageDateRange.end}`, 'fullmonth')}</strong> </p>
                                    }
                                    <div className="">
                                        <CustomCharts chartType='line' chartLabels={usageChartData?.dates || []} chartValues={usageChartData?.hits || []} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6 ps-0 ps-md-4 ps-lg-4 pe-0 mt-4 mt-md-0 mt-lg-0">
                                <div className="chart-container p-3">
                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        <p className="mb-0 font-16 weight-500 text-capitalize text-sec-color">API Health</p>
                                        <div className="dropdown chart-filters-dropdown">
                                            <button className="dropdown-toggle border-0 font-13 text-sec-color text-capitalize weight-500 text-start" type="button" id="mfChartMenu" data-bs-toggle="dropdown" aria-expanded="false">
                                                {currentHealthFilter.name}
                                            </button>
                                            <ul className="chart-filters-dropdown-menu dropdown-menu" aria-labelledby="mfChartMenu">
                                                <li onClick={() => handleDropdownFilterChange('status', { id: 5, name: 'Today' })} data-active={currentHealthFilter.id === 5} className='cursor-pointer font-13 weight-400 text-capitalize'>Today</li>
                                                {
                                                    filterDropdownOptions.map((item, index) => (
                                                        <li key={index} onClick={() => handleDropdownFilterChange('status', item)} data-active={item.id === currentHealthFilter.id} className='cursor-pointer font-13 weight-400 text-capitalize'>{item.name}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    {
                                        currentHealthFilter.id === 4 &&
                                        <p className="mb-3 font-13 weight-400">Showing API results between <strong>{formatDate(`${healthDateRange.start}`, 'fullmonth')}</strong> to <strong>{formatDate(`${healthDateRange.end}`, 'fullmonth')}</strong> </p>
                                    }
                                    <div className="">
                                        <CustomCharts chartType='pie' chartLabels={[]} chartValues={[]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Share route='live' show={showShare} callback={() => { setShowShare(false) }} id={`${decodeURIComponent(decrypt(params.id))}`} apiGroupName={group_name || ''} />

            <ModalWrapper ref={dateModalRef} title="Select date range" callback={resetDates}>
                <form className="track-daterange" onSubmit={onDatesSubmit}>
                    <div className="mb-3">
                        <CustomDatepicker
                            onChange={handleDateSelection}
                            label='Start date'
                            required={true}
                            selectedDate={currentModalName === 'usage' ? usageDateRange.start : healthDateRange.start}
                            calenderKey='start'
                            minDate={minCalendarDate}
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="mb-3">
                        <CustomDatepicker
                            onChange={handleDateSelection}
                            label='End date'
                            required={true}
                            selectedDate={currentModalName === 'usage' ? usageDateRange.end : healthDateRange.end}
                            calenderKey='end'
                            minDate={currentModalName === 'usage' ? usageDateRange.start : healthDateRange.start}
                            maxDate={new Date()}
                        />
                    </div>
                    {err.length !== 0 && <p className="my-1 font-13 error-text-color">{err}</p>}
                    <div className="mt-4 mb-2">
                        <CustomButton type='submit'>Get details</CustomButton>
                    </div>
                </form>
            </ModalWrapper>
        </MainContainer>
    )
}

export default LiveAPI